export const isValidEmail = (value) => {
    return new RegExp(
        "^[\\w\\-\\.]+@[\\w\\.\\-]+\\.+[\\w-]{2,4}$"
    ).test(value);
};

